export default __webpack_public_path__ + "static/media/Hair_8_M_C3.ff887575.svg";